module.exports = __webpack_public_path__ + "static/media/stockRoom.148ffe4c.png";